import { render, staticRenderFns } from "./SurveyFromListTrigger.vue?vue&type=template&id=b28c90e0"
import script from "./SurveyFromListTrigger.vue?vue&type=script&lang=js"
export * from "./SurveyFromListTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports